function country() {
    $.ajax({
        type: 'GET',
        url: 'http://api.londrinaweb.com.br/PUC/Paisesv2/0/1000',
        contentType: "application/json; charset=utf-8",
        dataType: "jsonp",
        async: false
    }).done(function (response) {

        paises = '';

        $.each(response, function (p, pais) {

            if (pais.Pais == 'Brasil') {
                paises += '<option value="' + pais.Pais + '" selected>' + pais.Pais + '</option>';
            } else {
                paises += '<option value="' + pais.Pais + '">' + pais.Pais + '</option>';
            }

        });
        // Select dos países
        $('#country').html(paises);

    });
}

country();

$(function () {
    // Mask CEP
    // $('#cep').mask('99999-999');

    $('#cep, #provider_zipcode, #zipcode').keyup(function () {
        var cep = $(this).val();
        var fa_cirle = ' fa-circle-o-notch fa-spin';
        var next_i = $(this).next('span').children('i');
        var marker_class = 'fa-map-marker';
        $(next_i).removeClass(marker_class);
        $(next_i).addClass(fa_cirle);

        if (cep.length >= 8) {
            $.ajax({
                data: JSON.stringify({
                    zipcode: cep
                }),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function(response){
                    if (response.success) {
                        $("#address, #provider_address").val(response.street);
                        $("#address_neighbour, #provider_address_neighborhood").val(response.district);
                        $("#address_city, #provider_address_city").val(response.city);
                        $("#state , #provider_state").val(response.state);
                        $("#country, #provider_country").val("Brasil");
                        $('#address_number, #provider_address_number').focus();
                    }
                    $(next_i).removeClass(fa_cirle);
                    $(next_i).addClass(marker_class);
                },
                error: function(){
                    $(next_i).removeClass(fa_cirle);
                    $(next_i).addClass(marker_class);
                },
                processData: false,
                type: 'POST',
                url: '/api/v1/application/zip_code/geocode'
            });
        } else {
            $(next_i).removeClass(fa_cirle);
            $(next_i).addClass(marker_class);
        }

    });
});